import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class FavIconService {
  baseUrl = '';

  constructor(private http: HttpClient) {
    this.baseUrl = environment.baseApiUrl;
  }

  /**
   * Gets the favicon for the current store.
   * Returns a Blob (image/x-icon) or 404 if not found.
   */
  getStoreFavicon(): Observable<Blob | null> {
    return this.http
      .get(`${this.baseUrl}favicon`, { responseType: 'blob', withCredentials: true })
      .pipe(
        catchError(() => {
          return of(null);
        }),
      );
  }

  setStoreFavicon(favicon: File | Blob): void {
    const reader = new FileReader();
    reader.onload = (event: ProgressEvent<FileReader>) => {
      const url = event.target?.result as string;
      this.updateFavicon(url);
    };
    reader.readAsDataURL(favicon);
  }

  /**
   * Updates the favicon link element in the document head.
   */
  private updateFavicon(dataUrl: string): void {
    let link: HTMLLinkElement | null = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.type = 'image/x-icon';
    link.href = dataUrl;
  }
}
